<template>
<div class="home">
  <img src="@/assets/bg.png" class="bg" />
  <div class="stepwrap">
    <img src="@/assets/step.png" class="step" />
    <div class="createwrap"
         @click="gocreate">
      <img src="@/assets/add.png" class="add" />
      创建新团体
    </div>
  </div>
  <div class="mewrap">
    <router-link :to="{name: 'MyTeam'}">
      <img src="@/assets/create.png" class="mel" />
    </router-link>
    <router-link :to="{name: 'JoinTeam'}">
      <img src="@/assets/join.png" class="mer" />
    </router-link>
  </div>
  <div class="readingwrap">
    <img src="@/assets/zy.png" class="zy">
    建议在使用本功能时，先阅读
    <span class="zytutal" @click="showTutorial">《证件照采集操作指南》</span>
  </div>
</div>
</template>

<script>
export default {
  name: 'Home',
  methods: {
    gocreate () {
      this.$router.push({
        name: 'CreateTeam'
      })
    },
    showTutorial () {
      this.$router.push({
        name: 'Tutorial'
      })
    }
  }
}

</script>

<style>
.home{
  min-height:100%;
  background-color: #F5F7FA;
}
.bg{
  width:100%;
}
.stepwrap{
  background-color: white;
  width:6.86rem;
  border-radius: .16rem;
  margin: -0.96rem auto .48rem;
  position: relative;
  padding-bottom: .48rem;
  box-shadow: 0 .24rem .36rem rgba(198, 198, 198, 0.29);
}
.step{
  width:100%;
  height:1.92rem;
  display: block;
  margin-bottom: .32rem;
}
.add{
  width:.36rem;
  height:.36rem;
  display: block;
  margin-right: .1rem;
}
.createwrap{
  width:5.9rem;
  height:0.8rem;
  border-radius: .12rem;
  background-color: #4710ED;
  font-size: .28rem;
  color:white;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  margin:0 auto;
}
.mewrap{
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  padding:0 .32rem;
  box-sizing: border-box;
}
.mel,.mer{
  width:3.2rem;
  height:3.2rem;
  flex-shrink: 0;
}
.readingwrap{
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  font-size: .24rem;
  color:#303133;
  margin-top: .28rem;
}
.zy{
  width:.34rem;
  height:.34rem;
  display: block;
  margin-right: .14rem;
}
.zytutal{
  color:#4710ED;
  font-weight: bold;
  padding:.2rem .1rem .2rem 0;
}
</style>
